export const environment = {
    production: false,

    ApiCore:'https://sfcartorio01.azurewebsites.net/api',

  env: 'DEV',
  AuthGoogle:{
    ClientId:"49081989713-80c29fp7rrutj6n3vbh84m3nkd9ogk6j.apps.googleusercontent.com"
  }

};
